import { useState, useEffect, useMemo } from "react";
import firestoreService from "../../services/firestoreService";
import { useParams, useSearchParams } from "react-router-dom";
import { useAuth } from "../auth/useAuth";
import { LECTURE_SCENARIO_STEPS } from "../../constants/lectureScenario";

export const useLectureDetail = () => {
  const { id: lectureId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);

  const baseLessons = useMemo(
    () => LECTURE_SCENARIO_STEPS.map((step) => ({ ...step })),
    []
  );

  const [navList, setNavList] = useState(() =>
    LECTURE_SCENARIO_STEPS.map((step) => ({ ...step }))
  );
  const [selectedNav, setSelectedNav] = useState(1);

  // nav type을 progress type으로 매핑
  const getProgressType = (navType) => {
    switch (navType) {
      case 'lecture':
        return 'video';
      case 'assignment':
        return 'writing';
      case 'quiz':
        return 'preproblem';
      case 'assessment':
        return 'feedback';
      case 'final':
        return 'repeat';
      default:
        return navType;
    }
  };

  // Progress 데이터 조회 및 navList 업데이트
  useEffect(() => {
    const fetchProgressData = async () => {
      if (!user?.uid || !lectureId) {
        setLoading(false);
        return;
      }
      
      try {
        setLoading(true);
        const progressTypes = ['LectureWriting', 'LecturePreProblem', 'LectureVideo', 'LectureFeedback', 'LectureRepeat'];
        
        const progressPromises = progressTypes.map(async (type) => {
          const result = await firestoreService.getDocument(`LectureProgress/${lectureId}/${type}`, user.uid);
          return { type: type.replace('Lecture', '').toLowerCase(), exists: result.success };
        });
        
        const results = await Promise.all(progressPromises);
        const progressMap = {};
        
        results.forEach(({ type, exists }) => {
          progressMap[type] = exists;
        });
        
        // navList 업데이트
        const updatedNavList = baseLessons.map(lesson => {
          const progressType = getProgressType(lesson.type);
          const isCompleted = progressMap[progressType] || false;
          
          return {
            ...lesson,
            completed: isCompleted
          };
        });
        
        setNavList(updatedNavList);
      } catch (error) {
        console.error('Progress 데이터 가져오기 실패:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProgressData();
  }, [user?.uid, lectureId, baseLessons]);
  
  useEffect(() => {
    const step = Number(searchParams.get("step"));
    if (step >= 1 && step <= LECTURE_SCENARIO_STEPS.length) {
      setSelectedNav(step);
    }
  }, [searchParams]);

  const onNavClickHandler = (index) => {
      setSelectedNav(index);
      setSearchParams({ step: String(index) }, { replace: true });
  }

  const onNavChangeHandler = (nav) => {
    const newNavList = [...navList];
    const index = newNavList.findIndex(item => item.id === nav.id);
    newNavList[index] = nav;
    setNavList(newNavList);
  }

  return {
      selectedNav,
      onNavClickHandler,
      onNavChangeHandler,
      navList,
      loading,
  }
}